var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "frameDragRoot", staticClass: "frameDragRoot" }, [
    _c("div", {
      directives: [
        {
          name: "frame-drag-line",
          rawName: "v-frame-drag-line",
          value: "left-top",
          expression: "'left-top'"
        }
      ],
      attrs: { role: "drag-rect-left-top" },
      on: {
        click: function($event) {
          $event.stopPropagation()
        }
      }
    }),
    _vm._v(" "),
    _c("div", {
      directives: [
        {
          name: "frame-drag-line",
          rawName: "v-frame-drag-line",
          value: "right-top",
          expression: "'right-top'"
        }
      ],
      attrs: { role: "drag-rect-right-top" },
      on: {
        click: function($event) {
          $event.stopPropagation()
        }
      }
    }),
    _vm._v(" "),
    _c("div", {
      directives: [
        {
          name: "frame-drag-line",
          rawName: "v-frame-drag-line",
          value: "right-bottom",
          expression: "'right-bottom'"
        }
      ],
      attrs: { role: "drag-rect-right-bottom" },
      on: {
        click: function($event) {
          $event.stopPropagation()
        }
      }
    }),
    _vm._v(" "),
    _c("div", {
      directives: [
        {
          name: "frame-drag-line",
          rawName: "v-frame-drag-line",
          value: "left-bottom",
          expression: "'left-bottom'"
        }
      ],
      attrs: { role: "drag-rect-left-bottom" },
      on: {
        click: function($event) {
          $event.stopPropagation()
        }
      }
    }),
    _vm._v(" "),
    _c("div", {
      directives: [
        {
          name: "frame-drag-line",
          rawName: "v-frame-drag-line",
          value: "left",
          expression: "'left'"
        }
      ],
      attrs: { role: "drag-line-left" },
      on: {
        click: function($event) {
          $event.stopPropagation()
        }
      }
    }),
    _vm._v(" "),
    _c("div", {
      directives: [
        {
          name: "frame-drag-line",
          rawName: "v-frame-drag-line",
          value: "right",
          expression: "'right'"
        }
      ],
      attrs: { role: "drag-line-right" },
      on: {
        click: function($event) {
          $event.stopPropagation()
        }
      }
    }),
    _vm._v(" "),
    _c("div", {
      directives: [
        {
          name: "frame-drag-line",
          rawName: "v-frame-drag-line",
          value: "top",
          expression: "'top'"
        }
      ],
      attrs: { role: "drag-line-top" },
      on: {
        click: function($event) {
          $event.stopPropagation()
        }
      }
    }),
    _vm._v(" "),
    _c("div", {
      directives: [
        {
          name: "frame-drag-line",
          rawName: "v-frame-drag-line",
          value: "bottom",
          expression: "'bottom'"
        }
      ],
      attrs: { role: "drag-line-bottom" },
      on: {
        click: function($event) {
          $event.stopPropagation()
        }
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-60fc29dc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60fc29dc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/szrt_revision/teachingDetail/list/classroom/imcomponents/imFrameDrag.vue
// module id = null
// module chunks = 